import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType, toRefs } from 'vue';
import { Participant, Wrestler } from '@/typings/wrestler';
import { useWrestlerStore } from '@/store/wrestlers';
import { SearchItem } from '@/typings/dropdown';
import SearchDropdown from '@/components/Inputs/SearchDropdown.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: [String, Number],
    required: true,
  },
  title: {
    type: String,
    default: null,
  },
  hint: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
  mask: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'text',
  },
  options: {
    type: Array as PropType<Array<string>>,
    default: () => [],
  },
  participants: {
    type: Array as PropType<Array<Participant>>,
    default: () => [],
  },
  status: {
    type: String,
  },
  informationText: {
    type: String,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props





const wrestlerStore = useWrestlerStore();

const { type: propType, participants, options: propOptions } = toRefs(props);

const options = computed(() => {
  return propOptions.value;
});
const optionObjects = computed<SearchItem[]>(() => {
  switch (propType.value) {
    case 'allWrestlers':
      return wrestlerStore.wrestlerSearchOptions;
    case 'multi':
      return options.value.map((o) => ({ text: o, value: o }));
    case 'fall':
      return ['Pin', 'Submission', 'Count Out', 'Disqualification'].map(
        (o) => ({ text: o, value: o })
      );
    case 'fallNDQ':
      return ['Pin', 'Submission'].map((o) => ({ text: o, value: o }));
    case 'cageFall':
      return ['Pin', 'Submission', 'Escape'].map((o) => ({
        text: o,
        value: o,
      }));
    case 'participating': {
      const wrestlers: Array<Wrestler | undefined> = [];
      for (const p of participants.value) {
        if (p.Team) {
          wrestlers.push(
            ...p.Team.Members.map((t) =>
              wrestlerStore.wrestlers.find((w) => w.SuperstarId === t)
            ).filter((w) => w !== undefined)
          );
        }
        if (p.Wrestler) {
          wrestlers.push(p.Wrestler);
        }
      }
      const onlyWrestlers: Wrestler[] = wrestlers.filter(
        (w: Wrestler | undefined) => w !== undefined
      ) as Wrestler[];
      return onlyWrestlers.map((w: Wrestler) => ({
        value: w.SuperstarId,
        text: w.Name,
      }));
    }
  }
  return [];
});

function onSelect(value: unknown) {
  emit('update:modelValue', value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SearchDropdown, {
    "model-value": __props.modelValue,
    title: __props.title,
    hint: __props.hint,
    disabled: __props.disabled,
    "validation-error": __props.validationError,
    placeholder: __props.placeholder,
    items: _unref(optionObjects),
    status: __props.status,
    "onUpdate:modelValue": onSelect
  }, _createSlots({ _: 2 }, [
    (__props.informationText)
      ? {
          name: "notes",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.informationText), 1)
          ])
        }
      : undefined,
    (_ctx.$slots['badge'])
      ? {
          name: "badge",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "badge")
          ])
        }
      : undefined
  ]), 1032, ["model-value", "title", "hint", "disabled", "validation-error", "placeholder", "items", "status"]))
}
}

})